/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import HoverTooltip from "../../../../../components/atoms/Tooltip/HoverTooltip";
import { pathogenicColors, benignColors } from "./constants";
import { weatheredStone } from "../../../../../common/helpers/colors";

const RuleColoredPill = (props) => {
  const { rule, metCriteria, acmgRules } = props;
  if (!rule) return null;
  const splittedRule = rule.split("_");
  const ruleName = splittedRule[0];
  const acmgDefaultRuleObj = acmgRules.find((element) => {
    return element.name === ruleName;
  });

  const ruleStrength = splittedRule[1] || acmgDefaultRuleObj.strength;
  const { description } = acmgDefaultRuleObj;
  const colorBasedOnStrength =
    rule.charAt(0) === "P"
      ? pathogenicColors[ruleStrength]
      : benignColors[ruleStrength];

  const color = !metCriteria ? weatheredStone : colorBasedOnStrength;
  return (
    <React.Fragment>
      <div
        className="tw-inline-block tw-items-center tw-w-fit tw-justify-end"
        style={{
          margin: "8px 2px",
          color: "white",
          backgroundColor: color,
          padding: "0 0.7em",
          borderRadius: "30px",
          border: `2px solid ${color}`,
        }}
      >
        <div className="tw-flex-1 tw-items-center tw-text-sm tw-font-bold tw-text-white">
          {`${rule} `}
          <HoverTooltip
            delay={500}
            ContentRenderer={() => {
              return (
                <div
                  style={{
                    maxWidth: "300px",
                  }}
                >
                  <div>
                    <span className="tw-font-bold">Rule Name: </span>
                    {ruleName}
                  </div>
                  <div>
                    <span className="tw-font-bold">Strength: </span>
                    {ruleStrength}
                  </div>
                  <div>
                    <span className="tw-font-bold">Definition: </span>
                    {description}
                  </div>
                  <div>
                    <span className="tw-font-bold">Criteria met: </span>
                    {metCriteria ? (
                      <FontAwesomeIcon
                        icon={faCheck}
                        size="lg"
                        fixedWidth={true}
                        className="tw-text-green-600"
                        tooltip="Yes"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faTimes}
                        size="lg"
                        fixedWidth={true}
                        className="tw-text-red-500"
                        tooltip="No"
                      />
                    )}
                  </div>
                </div>
              );
            }}
          >
            <i
              className="fa fa-question-circle tw-cursor-pointer tw-text-white tw-opacity-70 hover:tw-opacity-100"
              style={{
                fontFamily: __IS_COMPONENTS_PORTAL__
                  ? "Font Awesome 5 Free"
                  : "FontAwesome",
                fontSize: "15px",
              }}
            />
          </HoverTooltip>
        </div>
      </div>
    </React.Fragment>
  );
};

RuleColoredPill.propTypes = {
  rule: PropTypes.string,
  metCriteria: PropTypes.bool,
  acmgRules: PropTypes.arrayOf(
    PropTypes.shape({
      evidence: PropTypes.string,
      met_criteria: PropTypes.bool,
      user_explain_failed: PropTypes.arrayOf(PropTypes.string),
      acmg_triggered_strength: PropTypes.string,
    })
  ),
};

RuleColoredPill.defaultProps = {
  rule: "",
  metCriteria: true,
  acmgRules: [],
};

const mapStateToProps = (state) => {
  return {
    acmgRules: state.acmgRules,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RuleColoredPill);
